export default (theme) => ({
  card: {
    marginBottom: 12,
    [theme.breakpoints.only('xl')]: {
      width: 237,
    },
  },
  regularFontWeight: {
    fontWeight: 300,
  },
  mediumFontWeight: {
    fontWeight: 500,
  },
  yellowText: {
    color: theme.palette.textColor.yellow2,
  },
  redText: {
    color: theme.palette.textColor.red,
  },
  paddingBox: {
    padding: '0 8px 8px',
  },
  paddingTop: {
    paddingTop: 8,
  },
  paddingBottom: {
    paddingBottom: 8,
  },
  paddingBottomSmall: {
    paddingBottom: 4,
  },
  inlineFlex: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  flexStart: {
    justifyContent: 'flex-start',
  },
  selfCenter: {
    alignSelf: 'center',
  },
  flexHeader: {
    alignItems: 'flex-start',
  },
  fixedWidth: {
    width: 'calc(100% - 30px)',
  },
  buttons: {
    width: 'auto',
    alignItems: 'center',
  },
  locationFlex: {
    display: 'flex',
    alignItems: 'center',
    // paddingRight: 10,
    overflow: 'hidden',
    '& > img': {
      marginRight: 10,
      marginLeft: 15,
      cursor: 'pointer',
    },
  },
  location: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  deleteButton: {
    minWidth: 24,
    height: 24,
    padding: 5,
    '&:hover': {
      background: `${theme.palette.background.default}!important`,
    },
    '&:focus': {
      background: `${theme.palette.background.default}!important`,
    },
  },
  archiveButton: {
    padding: 0,
    minWidth: 24,
    marginRight: 3,
    '&:hover': {
      background: `${theme.palette.background.default}!important`,
    },
    '&:focus': {
      background: `${theme.palette.background.default}!important`,
    },
  },
  secondaryText: {
    color: theme.palette.textColor.secondary,
    fontSize: '0.8rem',
    fontWeight: 400,
    marginRight: 10,
  },
  displayBlock: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  photoWrapper: {
    borderRadius: '50%',
    border: `1px solid ${theme.palette.textColor.blue}`,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    width: 32,
    height: 32,
    transform: 'rotate(135deg)',
    minWidth: 32,
  },
  photo: {
    display: 'block',
    transform: 'rotate(-135deg)',
    maxWidth: 26,
    borderRadius: '50%',
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  name: {
    wordBreak: 'break-word',
  },
  forceAccount: {
    display: 'inline',
    color: `${theme.palette.textColor.white}`,
    backgroundColor: theme.palette.primary.blue,
    borderRadius: 9,
    padding: '3px 5px',
  },
  flexWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    minWidth: 65,
    marginLeft: 10,
  },
  paddingTopSmall: {
    paddingTop: '3px',
  },
  itemsFlexStart: {
    alignItems: 'flex-start',
  },
  widthAuto: {
    width: 'auto',
  },
  fullWidth: {
    width: '100%',
  },
  overflowHidden: {
    overflow: 'hidden',
  },
  dayBorder: {
    border: `1px solid ${theme.palette.textColor.yellow}`,
  },
  nightBorder: {
    border: `1px solid ${theme.palette.textColor.darkBlue}`,
  },
  inactiveBorder: {
    border: `1px solid ${theme.palette.textColor.secondary}`,
  },
  photoWrapper: {
    borderRadius: '50%',
    border: `1px solid ${theme.palette.textColor.blue}`,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    width: 20,
    height: 20,
    transform: 'rotate(135deg)',
    minWidth: 20,
    boxSizing: 'border-box',
  },
  username: {
    marginLeft: 8,
    paddingRight: 5,
    wordBreak: 'break-word',
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  day: {
    color: theme.palette.textColor.yellow,
  },
  night: {
    color: theme.palette.textColor.darkBlue,
  },
  inactive: {
    color: theme.palette.textColor.secondary,
  },
  justifyContentStart: {
    justifyContent: 'flex-start',
  },
  marginBottomSmall: {
    marginBottom: 4,
  },
  itemWrapper: {
    border: `1px solid ${theme.palette.borderColor.white}`,
    width: 'fit-content',
    maxWidth: '100%',
  },
  equipmentNumber: {
    boxSizing: 'border-box',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: theme.palette.textColor.white,
    padding: '3px 6px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 180,
  },
  equipmentBlock: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '17px',
    width: 'max-content',
    maxWidth: '100%',
    height: 20,
  },
  expand: {
    transform: 'rotate(0deg)',
    padding: '0 10px',
    '&:hover': {
      color: theme.palette.textColor.secondary,
      backgroundColor: 'transparent',
    },
    '&:focus': {
      color: theme.palette.textColor.secondary,
      backgroundColor: 'transparent',
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  missingCL: {
    borderColor: theme.palette.borderColor.red,
    boxShadow: `0px 0px 5px 2px ${theme.palette.borderColor.red}`,
    '-webkit-box-shadow': `0px 0px 5px 2px ${theme.palette.borderColor.red}`,
    '-moz-box-shadow': `0px 0px 5px 2px ${theme.palette.borderColor.red}`,
  },
  shiftColorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    padding: '10px 8px 8px 8px',
    borderBottom: `1px solid ${theme.palette.borderColor.primary}`,
  },
  bottomWrapper: {
    display: 'block',
    padding: 8,
    maxWidth: '100%',
    '& p': {
      fontSize: 14,
    },
  },
  dayShift: {},
  nightShift: {
    backgroundColor: theme.palette.background.nightShift,
    maxWidth: '100%',
  },
});
